import * as ng from 'angular';
import {ArchiSmallServices} from '../../../../services/archismall.service';
import {rabbitMQ} from '../../../../third/rabbitMQ';

class WorkerDownloadCsvClientiModalController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$uibModal',
    '$state',
    'store',
    'ArchiSmallServices',
    '$timeout',
    '$uibModalStack'
  ];

  private close: any;

  constructor(
    private $scope: any,
    private $rootScope: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $state: ng.ui.IStateService,
    private store: ng.a0.storage.IStoreService,
    private ArchiSmallServices: ArchiSmallServices,
    private $timeout: ng.ITimeoutService,
    private $uibModalStack: ng.ui.bootstrap.IModalStackService
  ) {

    $scope.startWorker = (startWorkerLoops) => {
      try {
        if (rabbitMQ.client.STATE === 0) {
          if (startWorkerLoops < 3) {
            setTimeout(() => {
              $scope.startWorker(startWorkerLoops + 1);
            }, 3000);
          } else {

            let modalInstance = $uibModal.open({
              animation: $scope.animationsEnabled,
              component: 'defaultModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {
                config: () => {
                  return {
                    headerIcon: 'fa fa-exclamation-triangle',
                    headerText: 'Errore',
                    bodyText: 'Non è stato possibile avviare la comunicazione con il server. N° tentativi ' + startWorkerLoops,
                    buttons: [
                      {
                        'id': 1,
                        'icon': 'fa fa-ban',
                        'label': 'Annulla'
                      },
                      {
                        'id': 2,
                        'icon': 'fa fa-check-circle-o',
                        'label': 'Riprova'
                      }
                    ]
                  };
                }
              }
            });
            modalInstance.result.then((pressedButtonId) => {
              if (pressedButtonId !== undefined) {
                if (pressedButtonId === 1) {
                  this.close();
                }
                if (pressedButtonId === 2) {
                  $scope.startWorker(startWorkerLoops + 1);
                }
              }
            }, () => {
              // ?
            });
          }
          return 0;
        }

        $scope.$parent.$resolve.settings.source = 'webApp';
        const key = $scope.$parent.$resolve.settings.key;

        const WORKER_MAP = {
          exportCsvData: 'worker_export_dati_conserve',
          yearToExport: 'worker_backoffice',
          exportCsvDataConserved: 'worker_export_csv_data_conserved'
        };

        const workerName = WORKER_MAP[$scope.$parent.$resolve.settings.key];

        if (!workerName) {
          console.warn('Unknown worker key:', key);
          return;
        }

        const payload = JSON.stringify($scope.$parent.$resolve.settings);
        rabbitMQ.send(workerName + $rootScope.workerNameSuffix, payload);

      } catch (err) {
        $rootScope.alert('error', err.message);
        return 0;
      }
      return 1;
    };

    $scope.workerResponse = $scope.startWorker(0);
    $scope.ok = () => {
      this.close();
    };
  }
}

export const WorkerDownloadCsvClientiModalComponent: ng.IComponentOptions = {
  template: require('./worker-download-csv-clienti-modal.html'),
  controller: WorkerDownloadCsvClientiModalController,
  bindings: {
    close: '&'
  }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/worker-download-csv-clienti-modal/worker-download-csv-clienti-modal.ts